import React, { useEffect, useState } from "react";
import "../Footer/Footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FaTwitter } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import projectlogo from "../../Assets/projectlogo.jpg"
import { MdOutlineKeyboardDoubleArrowUp } from "react-icons/md";

const Footer = () => {
  const [showScroll, setShowScroll] = useState(false);

  const handleTransparency = () => {
    window.open('/Transparency', '_blank');
  }
  const handleAboutUs = () => {
    window.open('/AboutUs', '_blank');
  };
  const handleContactUs = () => {
    window.open('/contactus', '_blank')
  }
  const handlePrivacyPolicy = () => {
    window.open('/PrivacyPolicy', '_blank')
  }

  const goToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handlescroll = () => {
      setShowScroll(window.pageYOffset > 600);
    };
    window.addEventListener("scroll", handlescroll);
    return () => {
      window.removeEventListener("scroll", handlescroll);
    };
  }, []);

  return (
    <div className="footer-container">
      {showScroll && (
        <button className="scroll_to_top" onClick={goToTop}>
          <MdOutlineKeyboardDoubleArrowUp />
        </button>
      )}
      <div className="footer-section">
        <div className="footer-wrapper">
          <div className="footer-heading text-center">
            <h2>
              NIL-Collab creates a more <span>supportive  environment</span>
            </h2>
          </div>
          <div className="container">
            <div className="footer-content row">
              <div className="footer-logo-section col-lg-4 col-xl-4 mt-4">
                <div className="footer-logo mb-4">
                  <a href="">
                    <img
                      src={projectlogo}
                      alt="BPP Logo"
                    />
                  </a>
                </div>
                <p className="footer-description">
                  Empowering Athletes Through Community Support and Transparency<br />
                </p>
              </div>

              <div className="footer-links-section col-lg-5 col-xl-4 ml-auto">
                <div className="second-row-cnt row">
                  <div className="footer-company-links col-6 mt-4">
                    <ul className="footer-menu">
                      <li>
                        <p onClick={handleAboutUs}>
                          About Us
                        </p>
                      </li>
                      <li>
                        <p onClick={handleTransparency}>
                          Transparency
                        </p>
                      </li>
                      <li>
                        <p
                          onClick={handlePrivacyPolicy}
                        >
                          Privacy Policy
                        </p>
                      </li>
                      <li>
                        <p
                          onClick={handleContactUs}
                        >
                          Contact Us
                        </p>
                      </li>
                    </ul>
                  </div>

                  <div className="footer-social-links col-6 mt-4">
                    <h6>Follow Us</h6>
                    <ul className="footer-social-icons">
                      <li>
                        <a
                          href="https://m.facebook.com/61575611559699/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaFacebookF />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://x.com/nilcollab?s=11"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaTwitter />
                        </a>
                      </li>
                      <li>
                        <a
                          href="http://Instagram.com/nilcollab"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaInstagram />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://youtube.com/@nilcollab?si=HAJtu_gmVJDgdMua"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaYoutube />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p className="text-footer">© 2025 NIL. All rights are reserved.
          </p></div>
      </div>


    </div>
  );
};

export default Footer;